import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { watch } from 'vue';
import { type AssetSummaryDtoV2 } from '@/api';
import i18n from '@/i18n';
import SiffletifyDataFooter from '@/components/siffletify/siffletify-data-footer/siffletify-data-footer.vue';
import NoDataAvailablePlaceholder from '@/components/placeholders/NoDataAvailablePlaceholder.vue';
import EntityPreviewCard from '@/components/cards/entity-preview-card/Entity-Preview-Card.vue';
import { DataOptions } from 'vuetify';

interface DataPagination {
  page: number;
  pageCount: number;
  itemsPerPage: number;
  itemsLength: number;
}

type AssetFilterType = 'TABLE_AND_VIEW' | 'DASHBOARD' | 'PIPELINE' | 'GENERIC';

interface ButtonInfo {
  text?: string;
  icon?: string;
  value: AssetFilterType | undefined;
}

interface DataProductsDrawerDataAssetsTabProps {
  assets: AssetSummaryDtoV2[];
  assetsCount: number;
}
interface DataProductsDrawerDataAssetsTabEmits {
  (event: 'update-filter', filter: AssetFilterType | undefined): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DataProductsDrawerDataAssetsTab',
  props: {
  assets: null,
  assetsCount: null,
  value: null
},
  emits: ["update-filter", "input"],
  setup(__props, { emit: emits }) {

const props = __props;




const { value: options } = __MACROS_useVModel(["value", undefined, "input"]);

const filterType = _ref<AssetFilterType | undefined>();

const items = _computed(() => props.assets || []);
const footerData = _computed(() => ({
  options: {
    page: options.value.page,
    itemsPerPage: options.value.itemsPerPage,
    itemsPerPageOptions: [10, 25, 50, 100],
  } as DataOptions & { itemsPerPageOptions?: number[] },
  pagination: {
    page: options.value.page,
    itemsPerPage: options.value.itemsPerPage,
    pageCount: props.assetsCount === 0 ? 0 : Math.ceil(props.assetsCount / options.value.itemsPerPage),
    itemsLength: props.assetsCount,
  } as DataPagination,
}));

const disablePagination = _computed(() => props.assetsCount === 0);

const updateOptions = (newOptions: { page: number; itemsPerPage: number }) => {
  options.value = {
    ...options.value,
    page: newOptions.page,
    itemsPerPage: newOptions.itemsPerPage,
  };
};

const buttons: Record<string, ButtonInfo> = {
  All: {
    text: i18n.t('common.words.All'),
    value: undefined,
  },
  TABLE_AND_VIEW: {
    text: i18n.t('data_products.right_drawer.btn_tables_and_views'),
    value: 'TABLE_AND_VIEW',
  },
  DASHBOARD: {
    text: i18n.t('data_products.right_drawer.btn_dashboards'),
    value: 'DASHBOARD',
  },
  PIPELINE: {
    text: i18n.t('data_products.right_drawer.btn_pipelines'),
    value: 'PIPELINE',
  },
  GENERIC: {
    icon: 'icon-menu-dots-horizontal',
    value: 'GENERIC',
  },
};

watch(() => filterType.value, (newValue) => {
  options.value.page = 1;
  emits('update-filter', newValue);
});


return { __sfc: true,props, emits, options, filterType, items, footerData, disablePagination, updateOptions, buttons, _ref, _computed, __MACROS_useVModel, watch, i18n, SiffletifyDataFooter, NoDataAvailablePlaceholder, EntityPreviewCard, DataOptions }
}

})